import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {BASE_URL} from "../ui-utils.js/apiConfig";

// Get base URL from environment variables
// const BASE_URL = process.env.REACT_APP_BASE_URL;

// Local
// const BASE_URL =  "http://localhost:5000";

// Staging
// const BASE_URL="https://tradeboss1-registration-service-staging.tradeboss.co"

// Production 
// const BASE_URL= "https://registration-service.tradeboss.co"


// Thunk to generate OTP
export const generateMobileOtp = createAsyncThunk(
  "users/generateOtp",
  async ({mobile, referral_code}, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.REG}/otp/generate/mobile`,
        {
          data: { mobile, referral_code},
        }
      );

      // Return the entire response to access user data
      console.log(response.data)
      return response.data.data;

    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const ReloginDirectStep = createAsyncThunk(
  "users/relogintodirectstep",
  async ({ mobile }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.REG}/otp/fetch-details`,
        { data: { mobile } }
      );

      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

// Thunk to verify OTP
export const verifyMobileOtp = createAsyncThunk(
  "users/verifyOtp",
  async ({ mobile, otp }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.REG}/otp/verify/mobile`,
        {
          data: { mobile, otp: Number(otp) },
        }
      );
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

// Generate Email OTP
export const generateEmailOtp = createAsyncThunk(
  "users/generateEmailOtp",
  async ({ mobile, email }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.REG}/otp/generate/email`,
        {
          data: {
            mobile,
            email,
          },
        }
      );
      return response.data;
    } catch (error) {

      console.log(rejectWithValue(error.response.data))
      return rejectWithValue(error.response.data);
    }
  }
);

// Verify Email OTP
export const verifyEmailOtp = createAsyncThunk(
  "users/verifyEmailOtp",
  async ({ mobile, email, otp }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.REG}/otp/verify/email`,
        {
          data: {
            mobile,
            email,
            otp,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Add this with your other thunks
export const verifyPan = createAsyncThunk(
  "users/verifyPan",
  async ({ mobile, email, pan_number }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.REG}/pan/verify`,
        {
          data: { mobile, email, pan_number }
        }
      );

      console.log(response.data)
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const generateAadharOtp = createAsyncThunk(
  "users/generateAadharOtp",
  async ({ mobile, email, aadhaar_number }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.REG}/aadhaar/otp`,
        {
          data: { mobile, email, aadhaar_number }
        }
      );

      console.log(response.data)
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
)

// Add this with your other thunks
export const verifyAadharOtp = createAsyncThunk(
  "users/verifyAadharOtp",
  async ({ mobile, email, aadhaar_number, otp, transaction_id }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.REG}/aadhaar/verify`,
        {
          data: {
            mobile,
            email,
            aadhaar_number,
            otp: otp,
            transaction_id
          }
        }
      );
      console.log(response.data.data)
      return response.data.data;
    } catch (err) {
      console.log(err.response.data)
      return rejectWithValue(err.response.data);
    }
  }
);

export const submitPersonalQuestionnaire = createAsyncThunk(
  "users/submitPersonalQuestionnaire",
  async ({ email, mobile, marital_status, guardian, gender }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.REG}/profile/questionnaires`,
        {
          data: {
            email,
            mobile,
            marital_status,
            guardian,
            gender,
            type: "PERSONAL"
          }
        }
      );
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const submitOccupationQuestionnaire = createAsyncThunk(
  "users/submitOccupationQuestionnaire",
  async ({ email, mobile, occupation, annual_income }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.REG}/profile/questionnaires`,
        {
          data: {
            email,
            mobile,
            occupation,
            annual_income,
            type: "OCCUPATION"
          }
        }
      );
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const submitQualificationQuestionnaire = createAsyncThunk(
  "users/submitQualificationQuestionnaire",
  async ({ email, mobile, investment_exp, qualification }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.REG}/profile/questionnaires`,
        {
          data: {
            email,
            mobile,
            investment_exp,
            qualification,
            type: "QUALIFICATION"
          }
        }
      );
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const submitNomineeDetails = createAsyncThunk(
  "users/submitNomineeDetails",
  async ({ email, mobile, nominee_name,
    nominee_relation,
    nominee_aadhaar,
    nominee_pincode,
    nominee_dob,
    nominee_skip }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.REG}/profile/nominee`,
        {
          data: {
            email,
            mobile,
            nominee_name,
            nominee_relation,
            nominee_aadhaar,
            nominee_pincode,
            nominee_dob,
            nominee_skip
          }
        }
      );
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const verifyBank = createAsyncThunk(
  "users/verifyBank",
  async ({ mobile, email, ifsc, accountNumber, accountType, upiId }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.REG}/bank/verify`,
        {
          data: {
            mobile,
            email,
            account_number: accountNumber,
            ifsc,
            account_type: accountType,
            upi_id: upiId
          },
        }
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
)


export const chequeUpload = createAsyncThunk(
  "users/chequeUpload",
  async ({ mobile, email, uploadData }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.REG}/bank/upload`,
        {
          data: {
            mobile,
            email,
            base64: uploadData,
          },
        }
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
)



export const confirmBank = createAsyncThunk(
  "users/confirmBank",
  async ({ mobile, email }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.REG}/bank/confirm`,
        {
          data: {
            mobile,
            email,
          },
        }
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
)


export const digilocker = createAsyncThunk(
  "users/digilocker",
  async ({ mobile, email,value }, { rejectWithValue }) => {
    try {
      let url
      if (value == "Setu"){
        url = `${BASE_URL.REG}/digilocker/setu-authorize`
       }else{
        url = `${BASE_URL.REG}/digilocker/authorize`
       }
      const response = await axios.post(
       url,
        {
          data: {
            mobile,
            email,
          },
        }
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
)


export const aadhaarUploadDigilocker = createAsyncThunk(
  "users/aadhaaruploadDigilocker",
  async ({ mobile, email, aadharUpload }, { rejectWithValue }) => {
    try {
      const response = await axios.post(

        `${BASE_URL.REG}/digilocker/upload`,
        {
          data: {
            mobile,
            email,
            upload_type: "ABSENT",
            aadhaarData: aadharUpload,

          },
        }
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
)



export const panUploadDigilocker = createAsyncThunk(
  "users/panuploadDigilocker",
  async ({ mobile, email, panData }, { rejectWithValue }) => {
    try {
      const response = await axios.post(

        `${BASE_URL.REG}/digilocker/upload`,
        {
          data: {
            mobile,
            email,
            upload_type: "ABSENT",
            panData
          },
        }
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
)


export const absentUploadDigilocker = createAsyncThunk(
  "users/absentUploadDigilocker",
  async ({ mobile, email, uploadType, panUpload, aadharUpload }, { rejectWithValue }) => {
    try {
      const response = await axios.post(

        `${BASE_URL.REG}/digilocker/upload`,
        {
          data: {
            mobile,
            email,
            upload_type: uploadType,
            panData: panUpload,
            aadhaarData: aadharUpload
          },
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
)


//dev-Ayush 22-04-2025 start
//generate QR
export const generateQR = createAsyncThunk(
  "users/generateQR",
  async ({ mobile, email, source , user }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.REG}/qr/generate`,
        {
          data: {
            mobile,
            email,
            source,
            user
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

//Capture Signature
export const Signature = createAsyncThunk(
  "users/signature",
  async ({ mobile, email, sign_data }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.REG}/signature/capture`,
        {
          data: {
            mobile,
            email,
            sign_data
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

//Signature Upload
export const SignatureUpload = createAsyncThunk(
  "users/signature_upload",
  async ({ mobile, email, base64 }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.REG}/signature/upload`,
        {
          data: {
            email,
            base64,
            mobile
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const retakeSignature = createAsyncThunk(
  "users/rake_signature",
  async ({ mobile, email, sign_data }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.ADMIN}/api/kyc/signature/verify`,
        {
          data: {
            email,
            sign_data,
            mobile
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);



export const fetchTokenData = createAsyncThunk(
  "api/kyc/links",
  async ({ token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.ADMIN}/api/kyc/links`,
        {
          data: {
            token
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateTokenData = createAsyncThunk(
  "api/kyc/links/update",
  async ({ token }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${BASE_URL.ADMIN}/api/kyc/links/${token}`
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

//fetch selfie or signature status
export const SeflieandSignatureStatus = createAsyncThunk(
  "users/seflie_and_signature_status",
  async ({ mobile, email, type }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.REG}/api/details/get_status`,
        {
          data: {
            email,
            type,
            mobile
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const retakeConfirm = createAsyncThunk(
  "users/retake/confirm",
  async ({ mobile, email, type,user_id }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        // `${BASE_URL.ADMIN}/api/kyc/retake/confirm`,
        `${BASE_URL.ADMIN}/api/kyc/retake/confirm`,
        {
          data: {
            email,
            type,
            mobile,
            user_id
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

//face Match
export const faceMatchApi = createAsyncThunk(
  "users/fatch_match",
  async ({ mobile, email, selfieImage,device }, { rejectWithValue }) => {

    console.log("LOG 3.1" ,JSON.stringify({
      email,
      mobile,
      url : BASE_URL.REG
    }))

    try {
      const response = await axios.post(
        `${BASE_URL.REG}/api/selfie/face-verify`,
        {
          data: {
            email,
            selfieImage,
            mobile,
            device
          },
        }
      );

      console.log("LOG 3.2" ,JSON.stringify(response))

      return response.data;
    } catch (error) {
      console.log("LOG 3.3" ,JSON.stringify(error))
      return rejectWithValue(error.response.data);
    }
  }
);

//liveness
export const liveness = createAsyncThunk(
  "users/liveness",
  async ({ mobile, email, selfieImage, ip, device }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.REG}/api/selfie/liveness-verfiy`,
        {
          data: {
            email,
            selfieImage,
            mobile,
            ip,
            device
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
//dev-Ayush 22-04-2025 end


export const retakeFaceMatchApi = createAsyncThunk(
  "users/retake_fatch_match",
  async ({ mobile, email, selfieImage,device }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.ADMIN}/api/kyc/selfie/face-verify`,
        {
          data: {
            email,
            selfieImage,
            mobile,
            device
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

//liveness
export const retakeLiveness = createAsyncThunk(
  "users/retake_liveness",
  async ({ mobile, email, selfieImage, ip, device }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.ADMIN}/api/kyc/selfie/liveness-verify`,
        {
          data: {
            email,
            selfieImage,
            mobile,
            ip,
            device
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const ocrCheck = createAsyncThunk(
  "users/ocr",
  async ({ mobile, email, filetype, type, base64 }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.REG}/api/document/validate`,
        {
          data: {
            mobile,
            email,
            type,
            filetype,
            base64: base64
          },
        }
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

// Add this async thunk
export const checkAndNavigate = createAsyncThunk(
  'users/checkAndNavigate',
  async (_, { getState, dispatch }) => {
    const { user } = getState();
    const excludedSteps = [
      "Add Nominee",
      "Activate F&O",
      "Subscription Plan",
      "Choose Segment",
      "Upload Documents",
      "Congrats Page",
      "POA",
      "Esign",
      "DIS Slip"
    ];
    
    const stepNames = Object.keys(user.userData.steps).filter(
      name => !excludedSteps.includes(name)
    );
    
    const allComplete = stepNames.every(stepName => user.userData.steps[stepName]?.status);
    
    return { allComplete };
  }
)

export const bankOcrCheck = createAsyncThunk(
  "users/chequeOcrCheck",
  async ({ mobile, email, filetype, type, base64 }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.REG}/api/document/validate`,
        {
          data: {
            mobile,
            email,
            type, // Now accepts different types like "cheque" or "bank_statement"
            filetype,
            base64
          },
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateNetWorth = createAsyncThunk(
  "users/updateNetWorth",
  async ({ mobile, email,net_worth }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.REG}/api/account-aggregator/net-worth`,
        {
          data: {
            mobile, email,net_worth
          },
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const uploadFnoDoc = createAsyncThunk(
  "users/uploadFnoDoc",
  async ({ mobile, email,document_type,base64,password }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.REG}/api/account-aggregator/upload`,
        {
          data: {
            mobile, email,document_type,base64,password
          },
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
)


export const fnoDoLater = createAsyncThunk(
  "users/fnoDoLater",
  async ({ mobile, email }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.REG}/api/account-aggregator/activate_later`,
        {
          data: {
            mobile, email
          },
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
)

export const checkPinCode = createAsyncThunk(
  "users/checkPinCode",
  async ({ pincode }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.REG}/api/details/pincode`,
        {
          data: {
            pincode
          },
        }
      );
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
)

export const esignProceed = createAsyncThunk(
  "users/esignProceed", async({ email,mobile ,source}, { rejectWithValue })=>{
 try {
      const response = await axios.post(
        `${BASE_URL.REG}/esign/authorize`,
        {
          data: {
           email,mobile,source
          },
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }


)

export const finalCall = createAsyncThunk(
  "users/finalCall", async({ email,mobile }, { rejectWithValue })=>{
 try {
      const response = await axios.post(
        `${BASE_URL.REG}/api/onboard/complete`,
        {
          data: {
           email,
           mobile,
           onboardingSource: "system",  
           crmUserName: null,
           crmUserId: null
          },
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }


)

export const getPlanDetails = createAsyncThunk(
  "users/getplanDetails",async({email,mobile,referral_code},{rejectWithValue})=>{
  try{
    const response = await axios.post(
        `${BASE_URL.REG}/api/details/get_plan_details`,
        {
          data: {
           email,mobile,referral_code
          },
        }
      );
      return response.data;
  }catch(err){
    return rejectWithValue(err.response.data);
  }
  }
)

export const skipPaymentAndProceed = createAsyncThunk(
  "users/skipPaymentAndProceed",async({email,mobile,referral_code},{rejectWithValue})=>{
  try{
    const response = await axios.post(
        `${BASE_URL.REG}/payment/fee`,
        {
          data: {
           email,mobile,referral_code
          },
        }
      );
      return response.data;
  }catch(err){
    return rejectWithValue(err.response.data);
  }
  }
)


export const disProceed = createAsyncThunk(
  "users/disProceed",async({email,mobile,dis_slip,dis_change,poa},{rejectWithValue})=>{
  try{
    console.log("dispayload", {
      data: {
        email, mobile, dis_slip, dis_change, poa : poa ? poa : false
      },
    })
    const response = await axios.post(
        `${BASE_URL.REG}/profile/dis-slip`,
        {
          data: {
            email,mobile,dis_slip,dis_change,poa: poa ? poa : false
          },
        }
      );
      return response.data;
  }catch(err){
    return rejectWithValue(err.response.data);
  }
  }
)


export const validateReferralCode = createAsyncThunk(
  'users/validateReferralCode',
  async (validationData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.REG}/otp/validate/referral`,
        {
          data: validationData
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)


export const callGoogleAuth = createAsyncThunk(
  'users/callGoogleAuth',
  async ({ code, mobile }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${BASE_URL.REG}/otp/google-auth`,
        {
          data: { code, mobile }
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)



// Get initial state from localStorage if available
const getInitialState = () => {
  return {
    loading: false,
    error: null,
    userData: null,
    activeStep: 0,
    panVerified: false,
    aadharVerified: false,
    personalData: null,
    nomineeData: null,
    digiDisp: false,
    questionnaire: {
      personal: null,
      occupationForm: null,
      qualificationForm: null
    },
    nominee: null,
    bankData: null,
    traditionalBank: true,
    bankDetailsPage: false,
    bankSuccess: false,
    chequeStatus: false,
    bankDetails: null,
    digilockerData: null,
    digiManualUplaod: false,
    manualStatus: false,
    aadharStatus: false,
    panStatus: false,
    digiStatus: true,
    digiReloadStatus: false,
    bankServerError :null,
    panDetails:{
      gender:null,
      guardian:null,
    },
    guardian:"",
    backToDigi: false,
    aadhaarOcr:false,
    uploadType: "",
    digiBackButton: true,
    is_verified:0,
    cleint_id:null,
    clientId: null,
    planData:null,
    refCodeDataFromEmail:null,
    faceMatch:false,
    panData:null,
    digiError:"",
    digiButClicked:false,
    digilockerCompleted:false,
    panOcr:false,
    chequeuploded:false,
    chequeuplodedFromRelogin:false,
    retakeAuth: {
      mobile: "",
      email: "",
      step: ""
    },
    retakeToken: false,
    retakeError: "",
    source:""
  };
};



const usersSlice = createSlice({
  name: "user",
  initialState: getInitialState(),
  reducers: {
    setSource:(state, action)=>{
       state.source = action.payload
    },
    setActiveStep: (state, action) => {
      state.activeStep = action.payload;
    },
    resetUser: (state) => {
      state.userData = null;
      state.error = null;
    },
    resetToInitial: (state,action) => {
      console.log("resett ")
      state.loading = false;
      state.error = null;
      state.userData = null;
      state.bankData = null;
      state.activeStep = 0;
      state.panVerified = false;
      state.aadharVerified = false;
      state.personalData = null;
      state.nomineeData = null;
      state.digilockerData = null;
      state.questionnaire = {
        personal: null,
        occupationForm: null,
        qualificationForm: null
      };
      state.nominee = null;
      state.traditionalBank = true;
      state.bankDetailsPage = false;
      state.bankSuccess = false;
      state.chequeStatus = false;
      state.digiManualUplaod = false
      state.bankDetails = null;
      state.digiStatus = true;
      state.manualStatus = false;
      state.aadharStatus = false;
      state.panStatus = false;
      state.digiReloadStatus = false;
      state.bankServerError = null;
      state.uploadType = "ABSENT";
      state.digiBackButton = true;
      state.panDetails={
        gender:null,
        guardian:null,
      };
      state.is_verified=0;
      state.cleint_id=null;
      state.clientId = null;
      state.planData=null;
      state.refCodeDataFromEmail=null;
      state.faceMatch =false
      state.panData = null;
      state.digiError=""
      state.digiDisp=false
      state.digiButClicked= false
      state.digilockerCompleted = false
      state.panOcr=false
      state.aadhaarOcr = false
      state.backToDigi = false
      state.guardian = ""
      state.chequeuploded=false
      state.chequeuplodedFromRelogin=false
      state.retakeAuth = {
        mobile: "",
        email: "",
        step: ""
      }
      state.retakeToken = false
      state.retakeError = ""
      state.source=action.payload
    },
    setPersonalDetails: (state, action) => {
      state.questionnaire.personal = action.payload
    },
    setGuardian :(state,action)=>{
      console.log("setGuardian", action.payload)
      state.guardian =action.payload
    },
    setOccupation: (state, action) => {
      state.questionnaire.occupationForm = action.payload
    },
    setQualification: (state, action) => {
      state.questionnaire.qualificationForm = action.payload
    },
    setPanData: (state, action)=>{
        state.panData=action.payload
    },
    setNominee: (state, action) => {
      state.nominee = action.payload
    },
    setPlanData:(state,action)=>{
      state.planData = action.payload
      state.planData.product_visibility = action.payload.product_visibility
      state.planData.expert_visibility= action.payload.expert_visibility
      state.planData.wealth_visibility = action.payload.wealth_visibility
    },
    setTraditionalToDetails: (state, action) => {
      state.traditionalBank = false;
      state.bankDetailsPage = true;
      state.bankDetails = action.payload;
      state.bankSuccess = false
    },
    setIsVerified:(state)=>{
      console.log("slice isverified")
       state.is_verified=1
    },
    setBackButton: (state) => {
      console.log("slice backbutton")
      state.digiBackButton = false
    },
    setDigiButtonClicked:(state)=>{
        state.digiButClicked =true
    },
    
    setDetailsToTraditional: (state) => {
      state.traditionalBank = true;
      state.bankDetailsPage = false;
    },
    setDisplay:(state)=>{
       state.digiDisp=true
    },
    setSuccess: (state) => {
      state.bankSuccess = true
      state.bankDetailsPage = false
      state.chequeStatus = false
      state.traditionalBank = false
    },
    setChequeUpload: (state) => {
      state.bankSuccess = false
      state.bankDetailsPage = false
      state.traditionalBank = false
      state.chequeStatus = true
    },
    setChequeToTraditional: (state) => {
      state.traditionalBank = true;
      state.chequeStatus = false;
      state.bankDetailsPage = false;
      state.bankSuccess = false
    },
    setPanOcrToTrue:(state)=>{
      state.panOcr=true
      state.aadhaarOcr = false
    },

    setAadhaarOcrToTrue: (state) => {
      state.aadhaarOcr = true
      state.panOcr = false
    },
    setDigiandmanualStatus: (state,action) => {
      console.log("actionnn",action.payload)
      state.digiStatus = false;
      state.manualStatus = true;
      state.digiManualUplaod = false;
      state.digiError=action?.payload
    },
    setDigiError:(state)=>{
      state.digiError = "We couldn’t retrieve your Aadhaar and PAN details at the moment. Kindly upload the documents manually."
    },
    setDigiDataBothStatus: (state) => {
      state.digilockerData.aadharStatus = true;
      state.digilockerData.panStatus = true;
    },
    setBothStatusTofalse: (state) => {
      state.aadharStatus = false;
      state.panStatus = false;
    },
    setDigiManualUploadStatus: (state) => {
      state.digiManualUplaod = true;
      state.digiStatus = false;
      state.manualStatus = false;
      state.panOcr=false;
      state.aadhaarOcr=false;
      state.digiError = "";

    },
    setUploadTypeToManual: (state) => {
      state.uploadType = "MANUAL"
    },
    setUploadTypeToAbsent: (state) => {
      state.uploadType = "ABSENT"
    },
    setDigiManualUploadStatusToFalse: (state) => {
      state.digiManualUplaod = false;
      state.digiStatus = true;
      state.backToDigi=true;
      state.digiError=""
    },
    setFaceMatchToTrue: (state) => {
      console.log("setFaceMatchToTrue")
      state.faceMatch = true;
    },
    setFaceMatchToFalse: (state) => {
      console.log("setFaceMatchToFalse")
      state.faceMatch = false;
    },
   
    setDigiDataAadhaarStatus: (state) => {
      state.digilockerData.aadharStatus = true;
    },
    setDigiDataPanStatus: (state) => {
      state.digilockerData.panStatus = true;

    },
    setDigiAadharStatus: (state) => {
      state.aadharStatus = true;
    },
    setDigiPanStatus: (state) => {
      state.panStatus = true;
    },
    setDigiStatus: (state,action) => {
      state.digiStatus = true
      state.manualStatus = false
      state.digiManualUplaod=false
      state.digiError = action?.payload
    },
    setAadharandPanStatus: (state) => {
      state.aadharStatus = true;
      state.panStatus = true;
    },

    setDigilockerCompleted: (state) => {
      state.digilockerCompleted = true;
    },
    setNomineeStatus: (state) => {
      const user = state.userData


      // If steps exist and Email Verify is one of the steps, update its status
      const updatedSteps = {
        ...user.steps,
        ["Add Nominee"]: {
          ...user.steps?.["Add Nominee"],
          status: true,
          timestamp: new Date().toISOString(), // optional, if you want to set a timestamp too
        },
      };

      state.userData = {
        ...state.userData,
        steps: updatedSteps,
      };
    },
     setProductStatus: (state) => {
      const user = state.userData
      // If steps exist and Email Verify is one of the steps, update its status
      const updatedSteps = {
        ...user.steps,
        ["Subscription Plan"]: {
          ...user.steps?.["Subscription Plan"],
          status: true,
          timestamp: new Date().toISOString(), // optional, if you want to set a timestamp too
        },
      };

      state.userData = {
        ...state.userData,
        steps: updatedSteps,
      };
    },

    setFnOStatusDoLater:(state)=>{
      const user = state.userData


      // If steps exist and Email Verify is one of the steps, update its status
      const updatedSteps = {
        ...user.steps,
        ["Activate F&O"]: {
          ...user.steps?.["Activate F&O"],
          status: true,
          timestamp: new Date().toISOString(), // optional, if you want to set a timestamp too
        },
      };

      state.userData = {
        ...state.userData,
        steps: updatedSteps,
      };
    },
    setuserData: (state, action) => {
      state.userData = action.payload
    },
    setpersonalData: (state, action) => {
      state.personalData = action.payload
    },
    setbankData: (state, action) => {
      state.bankData = action.payload
    },
    setDigiData: (state, action) => {
      state.digilockerData = action.payload
    },
    setNomineData: (state, action) => {
      state.nomineeData = action.payload
    },
    setEmailData: (state, action) => {
      state.userData.email = action.payload.email
    },
    setEmailStatus: (state, action) => {

      const user = state.userData


      // If steps exist and Email Verify is one of the steps, update its status
      const updatedSteps = {
        ...user.steps,
        ["Email Verify"]: {
          ...user.steps?.["Email Verify"],
          status: true,
          timestamp: new Date().toISOString(), // optional, if you want to set a timestamp too
        },
      };

      state.userData = {
        ...state.userData,
        steps: updatedSteps,
      };
    },
    setPanStatus: (state, action) => {
      state.panVerified = true; // Add this line

      // Update PAN verification status in steps
      const updatedSteps = {
        ...state.userData.steps,
        ["Pan Verify"]: {
          status: true,
          timestamp: new Date().toISOString()
        }
      };

      state.userData = {
        ...state.userData,
        steps: updatedSteps
      };
      console.log(action.payload)
      state.panDetails.gender=action.payload.gender
      // state.panDetails.guardian=action.payload.guardian
    },
    setAadharStatus: (state,action) => {
      state.aadharVerified = true; // Add this line

      const updatedSteps = {
        ...state.userData.steps,
        "Aadhaar Verify": {
          status: true,
          timestamp: new Date().toISOString()
        }
      };
      state.userData = {
        ...state.userData,
        steps: updatedSteps
      };
      // state.panDetails.guardian=action.payload.guardian
    },

    setPanStatusTofalse: (state) => {
      state.panStatus = false;
    },

    setAadharStatusTofalse: (state) => {
      state.aadharStatus = false;
    },


    setDigiReload: (state) => {
      state.digiReloadStatus = true
    },

    //dev-Ayush 22-04-2025
    setDummyUser : (state) =>{
      state.userData = {
        steps: []
      };
    },
    setBankDetailsToNull: (state) => {
      state.bankDetails = null;
      state.bankData=null
    },
    setDigiStepStatus: (state) => {

      console.log("insideeeeee")
      const user = state.userData
      // Update PAN verification status in steps
      const updatedSteps = {
        ...user.steps,
        ["DigiLocker KYC verified Docs"]: {
          ...user.steps?.["DigiLocker KYC verified Docs"],
          status: true,
          timestamp: new Date().toISOString(), // optional, if you want to set a timestamp too
        },
      };

      console.log("updatedSteps", updatedSteps)
      state.userData = {
        ...state.userData,
        steps: updatedSteps,
      };
    },
    setBankServerError: (state, action) => {
      state.bankServerError = action.payload
    },
    setDigilockerNextStep:(state)=>{
      const user = state.userData
      // Update PAN verification status in steps
      const updatedSteps = {
        ...user.steps,
        ["DigiLocker KYC verified Docs"]: {
          ...user.steps?.["DigiLocker KYC verified Docs"],
          status: true,
          timestamp: new Date().toISOString(), // optional, if you want to set a timestamp too
        },
      };

      console.log("updatedSteps", updatedSteps)
      state.userData = {
        ...state.userData,
        steps: updatedSteps,
      };
    },
    setOkToDetails: (state) => {
      state.traditionalBank = false;
      state.chequeStatus = false;
      state.bankDetailsPage = true;
      state.bankSuccess = false
    },
    setOkToTraditional:(state)=>{
      state.traditionalBank = true;
      state.chequeStatus = false;
      state.bankDetailsPage = false;
      state.bankSuccess = false
    },
    setPaymentStatus:(state)=>{
        const user = state.userData
      // Update PAN verification status in steps
      const updatedSteps = {
        ...user.steps,
        ["Subscription Plan"]: {
          ...user.steps?.["Subscription Plan"],
          status: true,
          timestamp: new Date().toISOString(), // optional, if you want to set a timestamp too
        },
      };

      console.log("updatedSteps", updatedSteps)
      state.userData = {
        ...state.userData,
        steps: updatedSteps,
      };
    },
     setEsignStatus:(state)=>{
        const user = state.userData
      // Update PAN verification status in steps
      const updatedSteps = {
        ...user.steps,
        ["Esign"]: {
          ...user.steps?.["Esign"],
          status: true,
          timestamp: new Date().toISOString(), // optional, if you want to set a timestamp too
        },
      };

      console.log("updatedSteps", updatedSteps)
      state.userData = {
        ...state.userData,
        steps: updatedSteps,
      };
    },
    setClientIdRx:(state,action)=>{
      state.cleint_id=action.payload
    },
    setClientId: (state, action) => {
      state.clientId = action.payload
    },
     setCongratsStatus:(state)=>{
      const user = state.userData


      // If steps exist and Email Verify is one of the steps, update its status
      const updatedSteps = {
        ...user.steps,
        ["Congrats Page"]: {
          ...user.steps?.["Congrats Page"],
          status: true,
          timestamp: new Date().toISOString(), // optional, if you want to set a timestamp too
        },
      };

      state.userData = {
        ...state.userData,
        steps: updatedSteps,
      };
    },
    setRefCodeFromEmail:(state,action)=>{
      state.refCodeDataFromEmail=action.payload.refCodeDataFromEmail
    },
    setDisStatus:(state)=>{
        const updatedSteps = {
        ...state.userData.steps,
        ["DIS Slip"]: {
          status: true,
          timestamp: new Date().toISOString()
        }
      };
      state.userData = {
        ...state.userData,
        steps: updatedSteps
      };
    },
    setChequeUploadStatus: (state, action) => {
      console.log("inside the chequeuploded reducer")
      console.log("chequeuploded", state.chequeuploded)
      state.chequeuploded = action.payload
    },
    setChequeUploadStatusFromRelogin: (state, action) => {
      console.log("inside the chequeuplodedFromRelogin reducer")
      console.log("chequeuplodedFromRelogin", state.chequeuplodedFromRelogin)
      state.chequeuplodedFromRelogin = action.payload
    },
    setRetakeTokenToTrue : (state)=>{
       state.retakeToken = true
    },
    setRetakeTokenToFalse: (state) => {
      state.retakeToken = false
    },
    setRetakeError : (state,action)=>{
       state.retakeError=action.payload
    },
    setRetakeAuth:(state,action)=>{
       state.retakeAuth.email=action.payload?.email;
       state.retakeAuth.mobile =action.payload?.mobile;
       state.retakeAuth.step =action.payload?.step
    }
  },
  extraReducers: (builder) => {
    builder
      // Generate Mobile OTP
      .addCase(generateMobileOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(generateMobileOtp.fulfilled, (state, action) => {
        state.loading = false;
        // For new users, response may not have user data
        console.log("From generateMobileOtp ER", action.payload.data?.user)
        // if (action.payload.data?.user) {
        //   state.userData = action.payload.data.user;
        // } else  {
        //   // Store just mobile for new users
        //   state.userData = { mobile: action.meta.arg };
        // }
        // if(action.payload.data?.personal){
        //   state.personalData=action.payload.data.personal;
        // }
        // if (action.payload.data?.bank){
        //   state.bankData = action.payload.data.bank;
        // }
        // if (action.payload.data?.digilocker) {

        //   state.digilockerData = action.payload.data.digilocker;
        // }

        // if (action.payload.data?.nominee) {
        //   state.nomineeData = action.payload.data.nominee;
        // }

      })
      .addCase(generateMobileOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to send OTP";
      })
      // Verify OTP cases
      .addCase(verifyMobileOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      // Verify Mobile OTP
      .addCase(verifyMobileOtp.fulfilled, (state, action) => {
        state.loading = false;
        // state.userData = action.payload.data.user;
      })
      .addCase(verifyMobileOtp.rejected, (state, action) => {
        state.loading = false;
        // state.error = action.payload?.message || "Invalid OTP";
      })
      // Generate Email OTP cases
      .addCase(generateEmailOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(generateEmailOtp.fulfilled, (state, action) => {
        state.loading = false;
        // Update userData with email
        // if (!state.userData) {
        //   state.userData = { email: action.meta.arg.email };
        // } else {
        //   state.userData.email = action.meta.arg.email;
        // }
        // // Merge any additional user data from response
        // if (action.payload.data?.user) {
        //   state.userData = { ...state.userData, ...action.payload.data.user };
        // }
      })
      .addCase(generateEmailOtp.rejected, (state, action) => {

        console.log(action.payload.data.data?.message)
        state.loading = false;
        // state.error = action.payload.data.data?.message || "Failed to send email OTP";
      })

      // Verify Email OTP cases
      .addCase(verifyEmailOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyEmailOtp.fulfilled, (state, action) => {
        state.loading = false;

        // const user=state.userData


        // // If steps exist and Email Verify is one of the steps, update its status
        // const updatedSteps = {
        //   ...user.steps,
        //   ["Email Verify"]: {
        //     ...user.steps?.["Email Verify"],
        //     status: true,
        //     timestamp: new Date().toISOString(), // optional, if you want to set a timestamp too
        //   },
        // };

        // state.userData = {
        //   ...state.userData,
        //   steps: updatedSteps,
        // };
      })
      .addCase(verifyEmailOtp.rejected, (state, action) => {
        console.log(action.payload)
        state.loading = false;
        // state.error = action.payload.data.data?.message || "Invalid email OTP";
      })
      // Add this to your extraReducers builder
      .addCase(verifyPan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyPan.fulfilled, (state, action) => {
        state.loading = false;
        // state.panVerified = true; // Add this line

        // // Update PAN verification status in steps
        // const updatedSteps = {
        //   ...state.userData.steps,
        //   "Pan Verify": {
        //     status: true,
        //     timestamp: new Date().toISOString()
        //   }
        // };

        // state.userData = {
        //   ...state.userData,
        //   steps: updatedSteps
        // };
      })
      .addCase(verifyPan.rejected, (state, action) => {
        console.log(action.payload)
        state.loading = false;
        // state.error = action.payload.data.data?.message || "PAN verification failed";
      })

      // Generate Aadhar OTP
      .addCase(generateAadharOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(generateAadharOtp.fulfilled, (state, action) => {
        state.loading = false;
        // You might want to store the transaction ID in state if needed elsewhere
        // state.transactionId = action.payload.transaction_id;
      })
      .addCase(generateAadharOtp.rejected, (state, action) => {
        console.log(action.payload)
        state.loading = false;
        // state.error =  state.error = action.payload.data.data?.message || "Failed to generate Aadhar OTP";
      })

      // Verify Aadhar OTP
      .addCase(verifyAadharOtp.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyAadharOtp.fulfilled, (state, action) => {
        state.loading = false;
        // state.aadharVerified = true; // Add this line

        // const updatedSteps = {
        //   ...state.userData.steps,
        //   "Aadhaar Verify": {
        //     status: true,
        //     timestamp: new Date().toISOString()
        //   }
        // };
        // state.userData = {
        //   ...state.userData,
        //   steps: updatedSteps
        // };
      })
      .addCase(verifyAadharOtp.rejected, (state, action) => {
        console.log(action.payload)
        state.loading = false;
        // state.error =  state.error = action.payload.data.data?.message || "Failed to generate Aadhar OTP";
      })


      // Personal Questionnaire
      .addCase(submitPersonalQuestionnaire.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitPersonalQuestionnaire.fulfilled, (state, action) => {
        state.loading = false;
        // state.questionnaire.personal = action.payload;
        const updatedSteps = {
          ...state.userData.steps,
          "Personal Detail": {
            status: true,
            timestamp: new Date().toISOString()
          }
        };
        state.userData = {
          ...state.userData,
          steps: updatedSteps
        };
      })
      .addCase(submitPersonalQuestionnaire.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to submit personal questionnaire";
      })

      // Occupation Questionnaire
      .addCase(submitOccupationQuestionnaire.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitOccupationQuestionnaire.fulfilled, (state, action) => {
        state.loading = false;
        // state.questionnaire.occupation = action.payload;
        const updatedSteps = {
          ...state.userData.steps,
          "Occupation": {
            status: true,
            timestamp: new Date().toISOString()
          }
        };
        state.userData = {
          ...state.userData,
          steps: updatedSteps
        };
      })
      .addCase(submitOccupationQuestionnaire.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to submit occupation questionnaire";
      })

      // Qualification Questionnaire
      .addCase(submitQualificationQuestionnaire.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitQualificationQuestionnaire.fulfilled, (state, action) => {
        state.loading = false;
        // state.questionnaire.qualification = action.payload;
        const updatedSteps = {
          ...state.userData.steps,
          "Qualification": {
            status: true,
            timestamp: new Date().toISOString()
          }
        };
        state.userData = {
          ...state.userData,
          steps: updatedSteps
        };
      })
      .addCase(submitQualificationQuestionnaire.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to submit qualification questionnaire";
      })

      .addCase(verifyBank.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(verifyBank.fulfilled, (state, action) => {
        state.loading = false;

      })
      .addCase(verifyBank.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Something Went wrong";
      })

      .addCase(chequeUpload.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(chequeUpload.fulfilled, (state, action) => {
        state.loading = false;
        const user = state.userData
       
        const updatedSteps = {
          ...user.steps,
          ["Link Bank Account"]: {
            ...user.steps?.["Link Bank Account"],
            status: true,
            timestamp: new Date().toISOString(), 
          },
        };

        state.userData = {
          ...state.userData,
          steps: updatedSteps,
        };

      })
      .addCase(chequeUpload.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Something Went wrong";
      })

      .addCase(confirmBank.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(confirmBank.fulfilled, (state, action) => {
        state.loading = false;
        const user = state.userData
        // Update PAN verification status in steps
        const updatedSteps = {
          ...user.steps,
          ["Link Bank Account"]: {
            ...user.steps?.["Link Bank Account"],
            status: true,
            timestamp: new Date().toISOString(), // optional, if you want to set a timestamp too
          },
        };

        state.userData = {
          ...state.userData,
          steps: updatedSteps,
        };
      })
      .addCase(confirmBank.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to upload";
      })


      .addCase(digilocker.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(digilocker.fulfilled, (state, action) => {
        state.loading = false;

        

      })
      .addCase(digilocker.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Digilocker Failed";
      })


      .addCase(aadhaarUploadDigilocker.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(aadhaarUploadDigilocker.fulfilled, (state, action) => {
        state.loading = false;

      })
      .addCase(aadhaarUploadDigilocker.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Something Went wrong while uploading Documents";
      })


      .addCase(panUploadDigilocker.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(panUploadDigilocker.fulfilled, (state, action) => {
        state.loading = false;

      })
      .addCase(panUploadDigilocker.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Something Went wrong while uploading Documents";
      })




      .addCase(absentUploadDigilocker.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(absentUploadDigilocker.fulfilled, (state, action) => {
        state.loading = false;

      })
      .addCase(absentUploadDigilocker.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Something Went wrong while uploading Documents";
      })

      .addCase(submitNomineeDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(submitNomineeDetails.fulfilled, (state, action) => {
        state.loading = false;

      })
      .addCase(submitNomineeDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload.data.data?.message || "Something Went wrong";
      })

      //dev-Ayush
      //generate qr code
      // .addCase(generateQR.pending, (state) => {
      //   state.loading = true;
      //   state.error = null;
      // })
      // .addCase(generateQR.fulfilled,(state)=>{
      //   state.loading = false;
      // })
      // .addCase(generateQR.rejected, (state, action) => {
      //   state.loading = false;
      //   state.error = action.payload?.message || "Error Generating QR";
      // })
      //

      //signature
      .addCase(Signature.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(Signature.fulfilled,(state,action)=>{
        state.loading = false;
        const {success} = action?.payload?.data?.data
        const user=state.userData

        if(success){
          const updatedSteps = {
            ...user.steps,
            Signature: {
              status: true,
              timestamp: new Date().toISOString(),
            },
          };
        
          state.userData = {
            ...state.userData,
            steps: updatedSteps,
          };
        }

      })
      .addCase(Signature.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Error capturing Signature";
      })

      //signature upload
      .addCase(SignatureUpload.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(SignatureUpload.fulfilled,(state,action)=>{
        state.loading = false;
        const {success} = action?.payload?.data?.data
        const user=state.userData

        if(success){
          const updatedSteps = {
            ...user.steps,
            Signature: {
              status: true,
              timestamp: new Date().toISOString(),
            },
          };
        
          state.userData = {
            ...state.userData,
            steps: updatedSteps,
          };
        }

      })
      .addCase(SignatureUpload.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Error Uploading Signature";
      })


      .addCase(retakeSignature.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(retakeSignature.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(retakeSignature.rejected, (state, action) => {
        state.loading = false;
        console.log("helloo error", action.payload, action.payload?.data?.data?.message)
        state.error = action.payload?.data?.data?.message || "Error Uploading Signature";
      })


      .addCase(fetchTokenData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTokenData.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(fetchTokenData.rejected, (state, action) => {
        state.loading = false;
        console.log("Error fetch token data", action.payload, action.payload?.data?.data?.message)
        state.error = action.payload?.data?.data?.message || "Error fetch token data";
      })



      .addCase(updateTokenData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateTokenData.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateTokenData.rejected, (state, action) => {
        state.loading = false;
        console.log("Error Update token data", action.payload, action.payload?.data?.data?.message)
        state.error = action.payload?.data?.data?.message || "Error Update token data";
      })

      //Selfie and signature status
      .addCase(SeflieandSignatureStatus.pending, (state) => {
        // state.loading = true;
        state.error = null;
      })
      .addCase(SeflieandSignatureStatus.fulfilled,(state,action)=>{
        const {status,type} = action?.payload?.data?.data
        let updatedData = {}
        if(type == "signature"){
           updatedData = { Signature : {
            status: true,
            timestamp: new Date().toISOString(),
          }
        }
      }
        if(type == "selfie"){
          updatedData = { "Capture Selfie" : {
           status: true,
           timestamp: new Date().toISOString(),
         }
       }

      }

        if(status){
          const user= state.userData
          const updatedSteps = {
            ...user.steps,
            ...updatedData
          };
    
          state.userData = {
            ...state.userData,
            steps: updatedSteps,
          };
        }
      })


      .addCase(SeflieandSignatureStatus.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Error getting Status";
      })


      .addCase(retakeConfirm.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(retakeConfirm.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(retakeConfirm.rejected, (state, action) => {
        state.loading = false;
        console.log("helloo error", action.payload, action.payload?.data?.data?.message)
        state.error = action.payload?.data?.data?.message || "Error Uploading Signature";
      })

      //signature upload
      .addCase(liveness.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(liveness.fulfilled,(state , action)=>{
        state.loading = false;
        const {success} = action?.payload?.data?.data
        const user=state.userData

        if(success){
          if(user){
          const updatedSteps = {
            ...user.steps,
            "Capture Selfie" : {
              status: true,
              timestamp: new Date().toISOString(),
            },
          };
        
          state.userData = {
            ...state.userData,
            steps: updatedSteps,
          };
        }
      }

      })
      .addCase(liveness.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Liveness Failed";
      })


      .addCase(retakeLiveness.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(retakeLiveness.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(retakeLiveness.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Liveness Failed";
      })

      .addCase(retakeFaceMatchApi.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(retakeFaceMatchApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(retakeFaceMatchApi.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Face Match Failed";
      })

      .addCase(ocrCheck.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(ocrCheck.fulfilled, (state, action) => {
        state.loading = false;

      })
      .addCase(ocrCheck.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Something Went wrong while uploading Cheque";
      })


      .addCase(bankOcrCheck.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(bankOcrCheck.fulfilled, (state, action) => {
        state.loading = false;

      })
      .addCase(bankOcrCheck.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Something Went wrong while uploading Cheque";
      })
      .addCase(uploadFnoDoc.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(uploadFnoDoc.fulfilled, (state, action) => {
        state.loading = false;
       
      })
      .addCase(uploadFnoDoc.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Validation failed";
      })
        .addCase(esignProceed.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(esignProceed.fulfilled, (state, action) => {
        state.loading = false;
       
      })
      .addCase(esignProceed.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Validation failed";
      })

      .addCase(getPlanDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPlanDetails.fulfilled, (state, action) => {
        state.loading = false;

      })
      .addCase(getPlanDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Something Went wrong while uploading Cheque";
      })
      .addCase(skipPaymentAndProceed.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(skipPaymentAndProceed.fulfilled, (state, action) => {
        state.loading = false;

      })
      .addCase(skipPaymentAndProceed.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Something Went wrong while uploading Cheque";
      })
       .addCase(finalCall.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(finalCall.fulfilled, (state, action) => {
        state.loading = false;

      })
      .addCase(finalCall.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Something Went wrong while uploading Cheque";
      })
       .addCase(disProceed.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(disProceed.fulfilled, (state, action) => {
        state.loading = false;

      })
      .addCase(disProceed.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Something Went wrong in disProceed";
      })
       .addCase(validateReferralCode.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(validateReferralCode.fulfilled, (state, action) => {
        state.loading = false;

      })    
      .addCase(validateReferralCode.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Something Went wrong in validateReferralCode";
      })
       .addCase(callGoogleAuth.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(callGoogleAuth.fulfilled, (state, action) => {
        state.loading = false;

      })
      .addCase(callGoogleAuth.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Something Went wrong in validateReferralCode";
      });
  },
});

export const { setActiveStep, resetToInitial, setPersonalDetails, setDigiDataPanStatus, setDigiDataAadhaarStatus, kycVerified, setDigiandmanualStatus, setAadharStatus, setDigiStatus, setPanStatus, setDigilockerCompleted, setAadharandPanStatus,setDetailsToTraditional, setTraditionalToDetails, setSuccess, setChequeUpload, setChequeToTraditional, setOccupation, setQualification, setNominee, setNomineeStatus, setuserData, setpersonalData, setbankData, setNomineData, setDigiData, setEmailData, setEmailStatus, setPanStatusTofalse, setAadharStatusTofalse, setDigiReload, setDummyUser, setDigiPanStatus, setDigiStepStatus, setDigilockerNextStep, setBankDetailsToNull, setBankServerError, setOkToDetails, setOkToTraditional, setDigiAadharStatus, setFnOStatusDoLater, setDigiDataBothStatus, setBothStatusTofalse, setDigiManualUploadStatus, setDigiManualUploadStatusToFalse, setUploadTypeToAbsent, setUploadTypeToManual, setBackButton, setIsVerified, setPaymentStatus, setEsignStatus, setClientIdRx, setCongratsStatus, setPlanData, setProductStatus, setRefCodeFromEmail, setFaceMatchToTrue, setPanData, setDisplay, setDisStatus, setDigiButtonClicked, setPanOcrToTrue, setAadhaarOcrToTrue, setChequeUploadStatus, chequeuplodedFromRelogin, setChequeUploadStatusFromRelogin, setDigiError, setGuardian, setAadhaarOcrToFalse, setClientId, setRetakeAuth, setRetakeTokenToTrue, setRetakeTokenToFalse, setRetakeError, setSource } = usersSlice.actions;
export default usersSlice.reducer;
